<template>
  <div class="buttons-container">
    <div v-for="e in buttonList" :key="e.id" class="main-button" @click="handleButtonFn(e.type)">
      <div class="google-shop-icon-box chxy-row-c-c">
        <img class="icon" :src="getImageUrlWithCDN_TEST(`/baixe/icon_${e.icon}.png`, 'local')" />
        <p class="value">{{ e.text }}</p>
      </div>
      <div class="gift-icon-box">
        <img class="icon" :src="getImageUrlWithCDN_TEST('/home/gift_icon.webp', 'local')" />
        <span class="value">{{ e.giftText }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useDevice } from '@/utils/useDevice'
import { debounce } from '@/utils/debounce'

const { t } = useI18n()

const buttonList = computed(() => [
  {
    id: 1,
    text: t('DownloadPopup-components-InstallButtonsReg.downloadApp'),
    giftText: t('DownloadPopup-components-InstallButtonsReg.earnGift'),
    icon: 'gift_pack',
    type: 'download',
  },
  {
    id: 2,
    text: t('DownloadPopup-components-InstallButtonsReg.depositNow'),
    giftText: t('DownloadPopup-components-InstallButtonsReg.depositBonus'),
    icon: 'wallet',
    type: 'deposite',
  },
])

const handleButtonFn = (type) => {
  switch (type) {
    case 'download':
      triggerInstallDebounce()
      break
    case 'deposite':
      emit('deposite')
      break
  }
}

const installPrompt = ref(null)
const { isIOS } = useDevice()

const init = (promptEvent) => {
  installPrompt.value = promptEvent
}

/**
 * 触发PWA安装流程
 */
function triggerInstall() {
  if (isIOS.value) {
    emit('download', { isIOS })
  } else {
    console.log('triggerInstall:', installPrompt.value)
    if (installPrompt.value) {
      // 使用之前保存的事件对象来触发安装提示
      installPrompt.value.prompt()

      // 等待用户选择结果
      installPrompt.value.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('用户同意安装')
        } else {
          console.log('用户拒绝安装')
        }
        // 清理保存的事件对象
        installPrompt.value = null
      })
      nextTick(() => {
        emit('download', { isIOS })
      })
    } else {
      emit('download', { isIOS })
    }
  }
}
const triggerInstallDebounce = debounce(triggerInstall)

onUnmounted(() => {
  installPrompt.value = null
})

const emit = defineEmits(['download', 'deposite'])

defineExpose({ init })
</script>

<style scoped lang="scss">
.buttons-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  .main-button {
    position: relative;
    width: 150px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 13px;
    border-radius: 6px;

    &:nth-of-type(1) {
      background: #f5f5f5;
      color: #26744a;
      border: 0.5px solid #26744a;
      box-sizing: border-box;
    }

    &:nth-of-type(2) {
      background: #26744a;
      color: var(--reg-greetings-popup-deposite-text);
    }

    .google-shop-icon-box {
      .icon {
        width: 20px;
        height: 20px;
      }

      .value {
        margin-left: 4px;
      }
    }

    .gift-icon-box {
      position: absolute;
      top: -26px;
      right: -6px;
      line-height: 1;

      .icon {
        position: absolute;
        left: -20px;
        bottom: -8px;
        width: 24px;
        height: 24px;
      }

      .value {
        display: inline-block;
        padding: 4px;
        background-color: var(--reg-greetings-popup-gift-tag-bg);
        border-radius: 10px 10px 10px 0;
        font-size: 10px;
        font-weight: 700;
        color: var(--reg-greetings-popup-gift-tag-text);
      }
    }
  }
}
</style>
